import axios from "axios";
import { getApiUrlWithVersion } from "./environmentService";
import { getAuthUser } from "./authService";
import {
  RequestEditionPlan,
  RequestEditionGenerateResponse,
  RequestEditionJobStatusResponse,
} from "../types/requestEdition";

class RequestEditionsService {
  private getAuthHeaders(): object {
    return {
      Authorization: getAuthUser()?.accessToken,
    };
  }

  async generatePlan(
    requestId: string,
    blueprintId: number
  ): Promise<RequestEditionPlan> {
    const response = await axios.post(
      `${getApiUrlWithVersion()}/request_editions/plan`,
      { request_id: requestId, blueprint_id: blueprintId },
      { headers: this.getAuthHeaders() }
    );
    return response.data;
  }

  async generate(
    requestId: string,
    blueprintId: number,
    plan: RequestEditionPlan
  ): Promise<RequestEditionGenerateResponse> {
    const response = await axios.post(
      `${getApiUrlWithVersion()}/request_editions/generate`,
      {
        request_id: requestId,
        blueprint_id: blueprintId,
        plan,
      },
      { headers: this.getAuthHeaders() }
    );
    return response.data;
  }

  async getStatus(jobId: string): Promise<RequestEditionJobStatusResponse> {
    const response = await axios.get(
      `${getApiUrlWithVersion()}/request_editions/status/${jobId}`,
      { headers: this.getAuthHeaders() }
    );
    return response.data;
  }
}

const requestEditionsService = new RequestEditionsService();
export default requestEditionsService;
